import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
  {
    path: "/",
    meta: {
      'title': '汽车时间_属于你的汽车时间_motortime.com',
      'keepAlive': true,
      // 'keywords':'汽车,汽车时间,汽车网,富士范儿,VTEC范儿,华系范儿,波子范儿,凌志范儿,汽车报价,汽车图片,视频,评测,社区,兴趣号,商城',
      'description':'汽车时间，提供汽车行业有特色的新闻资讯、汽车图片、要闻推送；同时，还有线下车友活动组织、线上汽车商品促销信息，满足您对汽车资讯需要。'
    },
    name: "Home",
    component: () => import("./views/Motortime/Home.vue")
  },
  {
    path: "/homedemo",
    meta: {
      'title': '汽车时间_属于你的汽车时间_motortime.com',
      'keepAlive': true,
      // 'keywords':'汽车,汽车时间,汽车网,富士范儿,VTEC范儿,华系范儿,波子范儿,凌志范儿,汽车报价,汽车图片,视频,评测,社区,兴趣号,商城',
      'description':'汽车时间，提供汽车行业有特色的新闻资讯、汽车图片、要闻推送；同时，还有线下车友活动组织、线上汽车商品促销信息，满足您对汽车资讯需要。'
    },
    name: "HomeDemo",
    component: () => import("./views/Motortime/Home-备份.vue")
  },
  {
    path: "/my",
    meta: {
      'title': '我的',
      'keepAlive': false
    },
    name: "My",
    component: () => import("./views/Motortime/My/My.vue")
  },
  {
    path: "/my/integral",
    meta: {
      'title': '我的积分',
      'keepAlive': false
    },
    name: "MyIntegral",
    component: () => import("./views/Motortime/My/Integral.vue")
  },
  {
    path: "/my/redpacket",
    meta: {
      'title': '我的红包',
      'keepAlive': false
    },
    name: "MyRedpacket",
    component: () => import("./views/Motortime/My/RedPacket.vue")
  },
  {
    path: "/my/redinfo",
    meta: {
      'title': '红包明细',
      'keepAlive': false
    },
    name: "MyRedinfo",
    component: () => import("./views/Motortime/My/RedInfo.vue")
  },
  {
    path: "/my/collect",
    meta: {
      'title': '我的收藏',
      'keepAlive': false
    },
    name: "MyCollect",
    component: () => import("./views/Motortime/My/MyCollect.vue")
  },
  {
    path: "/my/ask",
    meta: {
      'title': '我的问答',
      'keepAlive': false
    },
    name: "MyAsk",
    component: () => import("./views/Motortime/My/MyAsk.vue")
  },
  {
    path: "/my/bbs",
    meta: {
      'title': '我的帖子',
      'keepAlive': false
    },
    name: "MyBbs",
    component: () => import("./views/Motortime/My/MyBbs.vue")
  },
  
  {
    path: "/my/cars",
    meta: {
      'title': '车主认证',
      'keepAlive': false
    },
    name: "MyCars",
    component: () => import("./views/Motortime/My/MyCars.vue")
  },
  {
    path: "/my/car-info",
    meta: {
      'title': '认证车主',
      'keepAlive': false
    },
    name: "MyCarInfo",
    component: () => import("./views/Motortime/My/CarInfo.vue")
  },
  {
    path: "/my/car-audit",
    meta: {
      'title': '审核',
      'keepAlive': false
    },
    name: "MyCarAudit",
    component: () => import("./views/Motortime/My/CarAudit.vue")
  },
  {
    path: "/my/message",
    meta: {
      'title': '消息',
      'keepAlive': false
    },
    name: "MyMessage",
    component: () => import("./views/Motortime/My/MyMessage.vue")
  },
  {
    path: "/my/info",
    meta: {
      'title': '用户信息',
      'keepAlive': false
    },
    name: "MyMemberInfo",
    component: () => import("./views/Motortime/My/MemberInfo.vue")
  },
  {
    path: "/my/safety",
    meta: {
      'title': '账号安全',
      'keepAlive': false
    },
    name: "MySafety",
    component: () => import("./views/Motortime/My/MySafety.vue")
  },
  {
    path: "/my/boundmobile",
    meta: {
      'title': '绑定手机号',
      'keepAlive': false
    },
    name: "BoundMobile",
    component: () => import("./views/Motortime/My/BoundMobile.vue")
  },
  {
    path: "/my/mobileaudit",
    meta: {
      'title': '审核',
      'keepAlive': false
    },
    name: "MobileAudit",
    component: () => import("./views/Motortime/My/MobileAudit.vue")
  },
  {
    path: "/my/error",
    meta: {
      'title': '审核',
      'keepAlive': false
    },
    name: "Error",
    component: () => import("./views/Motortime/My/Error.vue")
  },
  {
    path: "/login",
    meta: {
      'title': '登录',
      'keepAlive': false
    },
    name: "Login",
    component: () => import("./views/Motortime/My/Login.vue")
  },
  {
    path: "/agreement",
    meta: {
      'title': '正文',
      'keepAlive': false
    },
    name: "Agreement",
    component: () => import("./views/Motortime/Page/Agreement.vue")
  },
  {
    path: "/privacy",
    meta: {
      'title': '隐私协议',
      'keepAlive': false
    },
    name: "Privacy",
    component: () => import("./views/Motortime/Page/Privacy.vue")
  },
  {
    path: "/carstate",
    meta: {
      'title': '汽车时间车主认证个人信息保护声明',
      'keepAlive': false
    },
    name: "Carstate",
    component: () => import("./views/Motortime/Page/Carstate.vue")
  },
  {
    path: "/article/:id/post",
    meta: {
      'title': '文章详情',
      'keepAlive': false
    },
    name: "ContentPostShow",
    component: () => import("./views/Motortime/Content/PostShow.vue")
  },
  {
    path: "/article/:id/pic",
    meta: {
      'title': '图集详情',
      'keepAlive': false
    },
    name: "ContentPicShow",
    component: () => import("./views/Motortime/Content/PicShow.vue")
  },
  {
    path: "/article/:id/video",
    meta: {
      'title': '视频详情',
      'keepAlive': false
    },
    name: "ContentVideoShow",
    component: () => import("./views/Motortime/Content/VideoShow.vue")
  },
  {
    path: "/index/index/information_info/id/:id",
    meta: {
      'title': '详情',
      'keepAlive': false
    },
    name: "Post",
    component: () => import("./views/Motortime/Content/Post.vue")
  },
  {
    path: "/detail-:id.html",
    meta: {
      'title': '详情',
      'keepAlive': false
    },
    name: "OldPost",
    component: () => import("./views/Motortime/Content/Post.vue")
  },
  {
    path: "/topicinfo/:id",
    meta: {
      'title': '话题详情',
      'keepAlive': false
    },
    name: "TopicInfo",
    component: () => import("./views/Motortime/Content/TopicInfo.vue")
  },
  {
    path: "/bbs",
    meta: {
      'title': '汽车时间社区',
      'keepAlive': true
    },
    name: "Bbs",
    component: () => import("./views/Motortime/Bbs/Index.vue")
  },
  {
    path: "/bbs/:id/channel",
    meta: {
      'title': '汽车时间社区',
      'keepAlive': true
    },
    name: "BbsChannel",
    component: () => import("./views/Motortime/Bbs/Channel.vue")
  },
  {
    path: "/bbs/:id",
    meta: {
      'title': '汽车时间社区',
      'keepAlive': false
    },
    name: "BbsShow",
    component: () => import("./views/Motortime/Bbs/Show.vue")
  },
  {
    path: "/ask",
    meta: {
      'title': '汽车时间问答',
      'keepAlive': true
    },
    name: "Ask",
    component: () => import("./views/Motortime/Ask/Index.vue")
  },
  {
    path: "/ask/:id/channel",
    meta: {
      'title': '汽车时间问答',
      'keepAlive': true
    },
    name: "AskChannel",
    component: () => import("./views/Motortime/Ask/Channel.vue")
  },
  {
    path: "/ask/:id/answer",
    meta: {
      'title': '汽车时间问答',
      'keepAlive': false
    },
    name: "AskShowAnswer",
    component: () => import("./views/Motortime/Ask/ShowAnswer.vue")
  },
  {
    path: "/ask/:id",
    meta: {
      'title': '汽车时间问答',
      'keepAlive': false
    },
    name: "AskShow",
    component: () => import("./views/Motortime/Ask/Show.vue")
  },
  {
    path: "/ask/:id/comment",
    meta: {
      'title': '汽车时间问答',
      'keepAlive': false
    },
    name: "AskShowComment",
    component: () => import("./views/Motortime/Ask/ShowComment.vue")
  },
  {
    path: "/lexus",
    meta: {
      'title': '凌志范儿',
      'keepAlive': true
    },
    name: "LexusHome",
    component: () => import("./views/Lexus/Home.vue")
  },
  {
   path: "/lexus/bbs/:id",
   meta: {
    'title': '凌志范儿社区',
    'keepAlive': false
  },
  name: "LexusBbsShow",
  component: () => import("./views/Lexus/Bbs/LexusBbsShow.vue")
},
{
 path: "/lexus/content",
 meta: {
  'title': '凌志范儿阅',
  'keepAlive': true
},
name: "LexusContentShow",
component: () => import("./views/Lexus/Content/Index.vue")
}, 
{
  path: "/lexus/article/:id/post",
  meta: {
    'title': '凌志范儿文章详情',
    'keepAlive': false
  },
  name: "LexusPostShow",
  component: () => import("./views/Lexus/Content/LexusPostShow.vue")
},
{
  path: "/lexus/article/:id/pic",
  meta: {
    'title': '凌志范儿图集详情',
    'keepAlive': false
  },
  name: "LexusPicShow",
  component: () => import("./views/Lexus/Content/LexusPicShow.vue")
},
{
  path: "/lexus/article/:id/video",
  meta: {
    'title': '凌志范儿视频详情',
    'keepAlive': false
  },
  name: "LexusVideoShow",
  component: () => import("./views/Lexus/Content/LexusVideoShow.vue")
},
{
  path: "/lexus/article/:id/player",
  meta: {
    'title': '直播',
    'keepAlive': false
  },
  name: "LexusPlayerShow",
  component: () => import("./views/Lexus/Content/LexusPlayerShow.vue")
},
{
 path: "/lexus/ask",
 meta: {
  'title': '凌志范儿问',
  'keepAlive': true
},
name: "LexusAsk",
component: () => import("./views/Lexus/Ask/AskIndex.vue")
},
{
  path: "/lexus/ask/:id/channel",
  meta: {
    'title': '凌志范儿问答',
    'keepAlive': false
  },
  name: "LexusAskChannel",
  component: () => import("./views/Lexus/Ask/Channel.vue")
},
{
  path: "/lexus/ask/:id/answer",
  meta: {
    'title': '凌志范儿问答',
    'keepAlive': false
  },
  name: "LexusAskShowAnswer",
  component: () => import("./views/Lexus/Ask/ShowAnswer.vue")
},
{
  path: "/lexus/ask/:id",
  meta: {
    'title': '凌志范儿问答',
    'keepAlive': false
  },
  name: "LexusAskShow",
  component: () => import("./views/Lexus/Ask/Show.vue")
},
{
  path: "/lexus/ask/:id/comment",
  meta: {
    'title': '凌志范儿问答',
    'keepAlive': false
  },
  name: "LexusAskShowComment",
  component: () => import("./views/Lexus/Ask/ShowComment.vue")
},
{
  path: "/lexus/content/:id/comment",
  meta: {
    'title': '凌志范儿',
    'keepAlive': false
  },
  name: "LexusContentShowComment",
  component: () => import("./views/Lexus/Content/ShowComment.vue")
},
{
  path: "/lexus/my",
  meta: {
    'title': '我的',
    'keepAlive': false
  },
  name: "LexusMy",
  component: () => import("./views/Lexus/My/My.vue")
},
{
  path: "/lexus/my/info",
  meta: {
    'title': '用户信息',
    'keepAlive': false
  },
  name: "LexusMyMemberInfo",
  component: () => import("./views/Lexus/My/MemberInfo.vue")
},
{
  path: "/lexus/my/boundmobile",
  meta: {
    'title': '绑定手机号',
    'keepAlive': false
  },
  name: "LexusBoundMobile",
  component: () => import("./views/Lexus/My/BoundMobile.vue")
},
{
  path: "/lexus/my/mobileaudit",
  meta: {
    'title': '审核',
    'keepAlive': false
  },
  name: "LexusMobileAudit",
  component: () => import("./views/Lexus/My/MobileAudit.vue")
},
{
  path: "/lexus/my/safety",
  meta: {
    'title': '账号安全',
    'keepAlive': false
  },
  name: "LexusMySafety",
  component: () => import("./views/Lexus/My/MySafety.vue")
},
{
  path: "/lexus/approvecar",
  meta: {
    'title': '车主认证',
    'keepAlive': true
  },
  name: "ApproveCar",
  component: () => import("./views/Lexus/Approve/ApproveCar.vue")
},
{
  path: "/lexus/my/approve",
  meta: {
    'title': '车主认证',
    'keepAlive': false
  },
  name: "CarApprove",                            
  component: () => import("./views/Lexus/My/CarApprove.vue")
},
{
  path: "/lexus/my/cars",
  meta: {
    'title': '车主认证',
    'keepAlive': false
  },
  name: "LexusMyCars",
  component: () => import("./views/Lexus/My/MyCars.vue")
},
{
  path: "/lexus/my/car_list",
  meta: {
    'title': '车主认证',
    'keepAlive': false
  },
  name: "LexusMyCarList",
  component: () => import("./views/Lexus/My/CarList.vue")
},
{
  path: "/lexus/my/car_gene",
  meta: {
    'title': '车主认证',
    'keepAlive': false
  },
  name: "LexusMyCarGene",
  component: () => import("./views/Lexus/My/CarGene.vue")
},
{
  path: "/lexus/my/car_model",
  meta: {
    'title': '车主认证',
    'keepAlive': false
  },
  name: "LexusMyCarModel",
  component: () => import("./views/Lexus/My/CarModel.vue")
},
{
  path: "/lexus/my/car_info",
  meta: {
    'title': '车主认证',
    'keepAlive': false
  },
  name: "LexusMyCarInfo",
  component: () => import("./views/Lexus/My/CarInfo.vue")
},
{
  path: "/lexus/my/car_audit",
  meta: {
    'title': '审核',
    'keepAlive': false
  },
  name: "LexusMyCarAudit",
  component: () => import("./views/Lexus/My/CarAudit.vue")
},
{
  path: "/lexus/my/checkcar_audit",
  meta: {
    'title': '审核',
    'keepAlive': false
  },
  name: "LexusMyCheckCarAudit",
  component: () => import("./views/Lexus/My/CheckCarAudit.vue")
},
{
  path: "/lexus/my/collect",
  meta: {
    'title': '我的收藏',
    'keepAlive': false
  },
  name: "LexusMyCollect",
  component: () => import("./views/Lexus/My/MyCollect.vue")
},
{
  path: "/lexus/my/ask",
  meta: {
    'title': '我的问答',
    'keepAlive': false
  },
  name: "LexusMyAsk",
  component: () => import("./views/Lexus/My/MyAsk.vue")
},
{
  path: "/lexus/my/message",
  meta: {
    'title': '消息',
    'keepAlive': false
  },
  name: "MyLexusMessage",
  component: () => import("./views/Lexus/My/MyMessage.vue")
},
{
  path: "/lexus/my/bbs",
  meta: {
    'title': '我的发布',
    'keepAlive': false
  },
  name: "LexusMyBbs",
  component: () => import("./views/Lexus/My/MyBbs.vue")
},
{
  path: "/lexus/my/comment",
  meta: {
    'title': '我的评论',
    'keepAlive': false
  },
  name: "LexusMyComment",
  component: () => import("./views/Lexus/My/MyComment.vue")
},
{
  path: "/lexus/topicmore",
  meta: {
    'title': '更多话题',
    'keepAlive': false
  },
  name: "LexusTopicMore",
  component: () => import("./views/Lexus/Bbs/TopicMore.vue")
},
{
  path: "/lexus/topicinfo/:id",
  meta: {
    'title': '话题详情',
    'keepAlive': false
  },
  name: "LexusTopicInfo",
  component: () => import("./views/Lexus/Bbs/TopicInfo.vue")
},
{
  path: "/lexus/my/index",
  meta: {
    'title': '我的',
    'keepAlive': true
  },
  name: "LexusMyIndex",
  component: () => import("./views/Lexus/My/Index.vue")
},
{
  path: "/lexus/my/other/:id",
  meta: {
    'title': '个人首页',
    'keepAlive': false
  },
  name: "LexusOther",
  component: () => import("./views/Lexus/My/Other.vue")
},
{
  path: "/lexus/my/honour",
  meta: {
    'title': '我的荣耀',
    'keepAlive': false
  },
  name: "LexusMyHonour",
  component: () => import("./views/Lexus/My/MyHonour.vue")
},
{
  path: "/lexus/my/honourinfo",
  meta: {
    'title': '荣耀说明',
    'keepAlive': false
  },
  name: "LexusHonourInfo",
  component: () => import("./views/Lexus/My/HonourInfo.vue")
},
{
  path: "/lexus/my/grade",
  meta: {
    'title': '我的等级',
    'keepAlive': false
  },
  name: "LexusMyGrade",
  component: () => import("./views/Lexus/My/MyGrade.vue")
},
{
  path: "/lexus/my/gradeinfo",
  meta: {
    'title': '等级特权',
    'keepAlive': false
  },
  name: "LexusMyGradeInfo",
  component: () => import("./views/Lexus/My/MyGradeInfo.vue")
},
{
  path: "/lexus/my/fans",
  meta: {
    'title': '我的粉丝',
    'keepAlive': false
  },
  name: "LexusMyFans",
  component: () => import("./views/Lexus/My/MyFans.vue")
},
{
  path: "/lexus/my/active",
  meta: {
    'title': '我的活动',
    'keepAlive': false
  },
  name: "LexusMyActive",
  component: () => import("./views/Lexus/My/MyActive.vue")
},
{
  path: "/lexus/my/activeinfo/:id",
  meta: {
    'title': '活动详情',
    'keepAlive': false
  },
  name: "LexusActiveInfo",
  component: () => import("./views/Lexus/My/ActiveInfo.vue")
},
{
  path: "/lexus/active/:id/comment",
  meta: {
    'title': '活动评论',
    'keepAlive': false
  },
  name: "LexusActiveComment",
  component: () => import("./views/Lexus/My/ActiveComment.vue")
},
{
  path: "/lexus/my/activeapply/:id",
  meta: {
    'title': '活动报名',
    'keepAlive': false
  },
  name: "LexusActiveApply",
  component: () => import("./views/Lexus/My/ActiveApply.vue")
},
{
  path: "/lexus/active/active",
  meta: {
    'title': '活动报名',
    'keepAlive': false
  },
  name: "LexusActive",
  component: () => import("./views/Lexus/Active/Active.vue")
},
{
  path: "/lexus/active/actived",
  meta: {
    'title': '活动报名',
    'keepAlive': false
  },
  name: "LexusActived",
  component: () => import("./views/Lexus/Active/Actived.vue")
},
{
  path: "/lexus/active/activeok",
  meta: {
    'title': '活动报名',
    'keepAlive': false
  },
  name: "LexusActiveok",
  component: () => import("./views/Lexus/Active/Activeok.vue")
},
{
  path: "/lexus/my/address",
  meta: {
    'title': '我的地址',
    'keepAlive': false
  },
  name: "LexusMyAddress",
  component: () => import("./views/Lexus/My/MyAddress.vue")
},
{
  path: "/lexus/my/createaddr",
  meta: {
    'title': '我的地址',
    'keepAlive': false
  },
  name: "LexusCreateAddr",
  component: () => import("./views/Lexus/My/CreateAddr.vue")
},
{
  path: "/lexus/my/cookies",
  meta: {
    'title': '浏览记录',
    'keepAlive': false
  },
  name: "LexusMyCookies",
  component: () => import("./views/Lexus/My/MyCookies.vue")
},
{
  path: "/lexus/my/fanslist/:type",
  meta: {
    'title': '关注/粉丝',
    'keepAlive': false
  },
  name: "LexusFansList",
  component: () => import("./views/Lexus/My/FansList.vue")
},
{
  path: "/lexus/my/otherfanslist/:id",
  meta: {
    'title': '粉丝',
    'keepAlive': false
  },
  name: "LexusOtherFansList",
  component: () => import("./views/Lexus/My/OtherFansList.vue")
},
{
  path: "/lexus/topic",
  meta: {
    'title': '选择话题',
    'keepAlive': false
  },
  name: "LexusTopic",
  component: () => import("./views/Lexus/Release/Topic.vue")
},
{
  path: "/lexus/createtopic",
  meta: {
    'title': '创建话题',
    'keepAlive': false
  },
  name: "LexusCreateTopic",
  component: () => import("./views/Lexus/Release/CreateTopic.vue")
},
{
  path: "/lexus/deltopic",
  meta: {
    'title': '删除话题',
    'keepAlive': false
  },
  name: "LexusDelTopic",
  component: () => import("./views/Lexus/Release/DelTopic.vue")
},
{
  path: "/lexus/asktype",
  meta: {
    'title': '问题类型',
    'keepAlive': false
  },
  name: "LexusAskType",
  component: () => import("./views/Lexus/Ask/AskType.vue")
},
{
  path: "/lexus/shop",
  meta: {
    'title': '商城',
    'keepAlive': true
  },
  name: "LexusShop",
  component: () => import("./views/Lexus/Shop/Index.vue")
},
{
  path: "/lexus/carstate",
  meta: {
    'title': '凌志范儿车主认证个人信息保护声明',
    'keepAlive': true
  },
  name: "Carstate",
  component: () => import("./views/Lexus/Page/Carstate.vue")
},
{
  path: "/lexus/carstateare",
  meta: {
    'title': '凌志范儿车主认证个人信息保护声明',
    'keepAlive': true
  },
  name: "CarstateAre",
  component: () => import("./views/Lexus/Page/CarstateAre.vue")
},
{
  path: "/lexus-falv",
  meta: {
    'title': '隐私协议',
    'keepAlive': true
  },
  name: "LzFalv",
  component: () => import("./views/Lexus/Lzfxy.vue")
},
{
  path: "/motor-falv",
  meta: {
    'title': '隐私协议',
    'keepAlive': true
  },
  name: "MoFalv",
  component: () => import("./views/Motortime/motorxy.vue")
},
{
  path: "/vtec-falv",
  meta: {
    'title': '隐私协议',
    'keepAlive': true
  },
  name: "VtecFalv",
  component: () => import("./views/Honda/vtecxy.vue")
},
{
  path: "/live/:id",
  meta: {
    'title': '直播',
    'keepAlive': true
  },
  name: "CarstateAre",
  component: () => import("./views/Lexus/Content/Live.vue")
},
{
  path: "/lexus/approvemy",
  meta: {
    'title': '身份认证',
    'keepAlive': true
  },
  name: "LexusApprovemy",
  component: () => import("./views/Lexus/Approve/Approvemy.vue")
},
{
  path: "/lexus/approvecen",
  meta: {
    'title': '认证中心',
    'keepAlive': true
  },
  name: "LexusApprovecen",
  component: () => import("./views/Lexus/Approve/Approvecen.vue")
},
{
  path: "/lexus/approveok",
  meta: {
    'title': '认证成功',
    'keepAlive': true
  },
  name: "LexusApproveok",
  component: () => import("./views/Lexus/Approve/Approveok.vue")
},
{
  path: "/lexus/invitein",
  meta: {
    'title': '影响力认证',
    'keepAlive': true
  },
  name: "LexusInvitein",
  component: () => import("./views/Lexus/Approve/LexusInvitein.vue")
},
{
  path: "/lexus/invite",
  meta: {
    'title': '影响力认证',
    'keepAlive': true
  },
  name: "LexusInvite",
  component: () => import("./views/Lexus/Approve/LexusInvite.vue")
},
{
  path: "/lexus/inviteok",
  meta: {
    'title': '认证审核',
    'keepAlive': true
  },
  name: "LexusInviteok",
  component: () => import("./views/Lexus/Approve/LexusInviteok.vue")
},
{
  path: "/lexus/inviteaudit",
  meta: {
    'title': '认证审核',
    'keepAlive': true
  },
  name: "LexusInviteaudit",
  component: () => import("./views/Lexus/Approve/LexusInviteaudit.vue")
},
{
  path: "/subaru/carstate",
  meta: {
    'title': '富士范儿车主认证个人信息保护声明',
    'keepAlive': true
  },
  name: "SubaruCarstate",
  component: () => import("./views/Subaru/Page/Carstate.vue")
},
{
  path: "/subaru-falv",
  meta: {
    'title': '正文',
    'keepAlive': true
  },
  name: "Fjfalv",
  component: () => import("./views/Subaru/Fjfxy.vue")
},
{
  path: "/clue-protect",
  meta: {
    'title': '个人信息保护声明',
    'keepAlive': true
  },
  name: "ClueProtect",
  component: () => import("./views/Subaru/ClueProtect.vue")
},
{
  path: "/active-state",
  meta: {
    'title': '森林人 STI SPORT全国品鉴会活动说明',
    'keepAlive': true
  },
  name: "ActiveState",
  component: () => import("./views/Subaru/activestate.vue")
},
{
  path: "/subaru/my/safety",
  meta: {
    'title': '账号安全',
    'keepAlive': false
  },
  name: "SubaruMySafety",
  component: () => import("./views/Subaru/My/MySafety.vue")
},
{
  path: "/subaru/my/boundmobile",
  meta: {
    'title': '绑定手机号',
    'keepAlive': false
  },
  name: "SubaruBoundMobile",
  component: () => import("./views/Subaru/My/BoundMobile.vue")
},
{
  path: "/subaru/approvemy",
  meta: {
    'title': '身份认证',
    'keepAlive': true
  },
  name: "SubaruApprovemy",
  component: () => import("./views/Subaru/Approve/Approvemy.vue")
},
{
  path: "/subaru/approvecen",
  meta: {
    'title': '认证中心',
    'keepAlive': true
  },
  name: "SubaruApprovecen",
  component: () => import("./views/Subaru/Approve/Approvecen.vue")
},
{
  path: "/subaru/approveok",
  meta: {
    'title': '认证成功',
    'keepAlive': true
  },
  name: "SubaruApproveok",
  component: () => import("./views/Subaru/Approve/Approveok.vue")
},
{
  path: "/subaru/invitein",
  meta: {
    'title': '影响力认证',
    'keepAlive': true
  },
  name: "SubaruInvitein",
  component: () => import("./views/Subaru/Approve/SubaruInvitein.vue")
},
{
  path: "/subaru/invite",
  meta: {
    'title': '影响力认证',
    'keepAlive': true
  },
  name: "SubaruInvite",
  component: () => import("./views/Subaru/Approve/SubaruInvite.vue")
},
{
  path: "/subaru/inviteok",
  meta: {
    'title': '认证审核',
    'keepAlive': true
  },
  name: "SubaruInviteok",
  component: () => import("./views/Subaru/Approve/SubaruInviteok.vue")
},
{
  path: "/subaru/inviteaudit",
  meta: {
    'title': '认证审核',
    'keepAlive': true
  },
  name: "SubaruInviteaudit",
  component: () => import("./views/Subaru/Approve/SubaruInviteaudit.vue")
},
{
  path: "/subaru/approvecar",
  meta: {
    'title': '车主认证',
    'keepAlive': true
  },
  name: "ApproveCar",
  component: () => import("./views/Subaru/Approve/ApproveCar.vue")
},
{
  path: "/subaru/qrcode",
  meta: {
    'title': '入场扫码',
    'keepAlive': true
  },
  name: "SubaruQrcode",
  component: () => import("./views/Subaru/Qrcode.vue")
},
{
  path: "/subaru/portrait",
  meta: {
    'title': '正文',
    'keepAlive': true
  },
  name: "SubaruPortrait",
  component: () => import("./views/Subaru/Portrait.vue")
},
{
  path: "/subaru/saidaoagreement",
  meta: {
    'title': '正文',
    'keepAlive': false
  },
  name: "SaiDaoAgreement",
  component: () => import("./views/Subaru/SaiDaoAgreement.vue")
},
{
  path: "/subaru/wechatagreement",
  meta: {
    'title': '富士范儿小程序隐私协议',
    'keepAlive': false
  },
  name: "SubaruWechatAgreement",
  component: () => import("./views/Subaru/WechatAgreement.vue")
},
{
  path: "/lexus/portrait",
  meta: {
    'title': '正文',
    'keepAlive': true
  },
  name: "LexusPortrait",
  component: () => import("./views/Lexus/Portrait.vue")
},
{
  path: "/lexus/wechatagreement",
  meta: {
    'title': '凌志范儿小程序隐私协议',
    'keepAlive': false
  },
  name: "LexusWechatAgreement",
  component: () => import("./views/Lexus/WechatAgreement.vue")
},
{
  path: "/honda/wechatagreement",
  meta: {
    'title': 'VTEC范儿小程序隐私协议',
    'keepAlive': false
  },
  name: "HondaWechatAgreement",
  component: () => import("./views/Honda/WechatAgreement.vue")
},
{
  path: "/wechatagreement",
  meta: {
    'title': '汽车时间小程序隐私协议',
    'keepAlive': false
  },
  name: "WechatAgreement",
  component: () => import("./views/Motortime/WechatAgreement.vue")
},
{
  path: "/shop/wechatagreement",
  meta: {
    'title': '汽车时间小程序隐私协议',
    'keepAlive': false
  },
  name: "ShopWechatAgreement",
  component: () => import("./views/Motortime/Shop/WechatAgreement.vue")
},
{
  path: "/subaru/safety",
  meta: {
    'title': '正文',
    'keepAlive': true
  },
  name: "SubaruSafety",
  component: () => import("./views/Subaru/Safety.vue")
},
{
  path: "/admin/home",
  meta: {
    'title': '管理员审核',
    'keepAlive': true
  },
  name: "AdminHome",
  component: () => import("./views/Admin/Home.vue")
},
{
  path: "/admin/login",
  meta: {
    'title': '管理员登录',
    'keepAlive': true
  },
  name: "AdminLogin",
  component: () => import("./views/Admin/Login.vue")
},
{
  path: "/admin/bbslist",
  meta: {
    'title': '论坛帖子审核',
    'keepAlive': true
  },
  name: "AdminBbslist",
  component: () => import("./views/Admin/Bbslist.vue")
},
{
  path: "/admin/bbsinfo/:id",
  meta: {
    'title': '论坛帖子详情',
    'keepAlive': true
  },
  name: "Bbsinfo",
  component: () => import("./views/Admin/Bbsinfo.vue")
},
{
  path: "/admin/bbscomment",
  meta: {
    'title': '帖子评论审核',
    'keepAlive': true
  },
  name: "AdminBbsComment",
  component: () => import("./views/Admin/BbsComment.vue")
},
{
  path: "/admin/articlecomment",
  meta: {
    'title': '文章评论审核',
    'keepAlive': true
  },
  name: "AdminArticleComment",
  component: () => import("./views/Admin/ArticleComment.vue")
},
{
  path: "/admin/adminkeywords",
  meta: {
    'title': 'Fans数据助手',
    'keepAlive': true
  },
  name: "AdminKeywords",
  component: () => import("./views/Admin/AdminKeywords.vue")
},
{
  path: "/admin/adminkeyword",
  meta: {
    'title': 'Fans数据助手',
    'keepAlive': true
  },
  name: "AdminKeyword",
  component: () => import("./views/Admin/AdminKeyword.vue")
},
{
  path: "/admin/keywordsearch",
  meta: {
    'title': '搜索页',
    'keepAlive': true
  },
  name: "KeywordSearch",
  component: () => import("./views/Admin/KeywordSearch.vue")
},
{
  path: "/admin/searchresult",
  meta: {
    'title': '搜索结果显示',
    'keepAlive': true
  },
  name: "SearchResult",
  component: () => import("./views/Admin/SearchResult.vue")
},
{
  path: "/admin/keywordmessage",
  meta: {
    'title': '消息管理页',
    'keepAlive': true
  },
  name: "KeywordMessage",
  component: () => import("./views/Admin/KeywordMessage.vue")
},
{
  path: "/admin/keywordwarning",
  meta: {
    'title': '预警消息管理详情',
    'keepAlive': true
  },
  name: "KeywordWarning",
  component: () => import("./views/Admin/KeywordWarning.vue")
},
{
  path: "/admin/keywordwarninginfo",
  meta: {
    'title': '论坛详情',
    'keepAlive': true
  },
  name: "KeywordWarningInfo",
  component: () => import("./views/Admin/KeywordWarningInfo.vue")
},
{
  path: "/admin/keywordnegative",
  meta: {
    'title': '负面情绪关键词',
    'keepAlive': true
  },
  name: "KeywordNegative",
  component: () => import("./views/Admin/KeywordNegative.vue")
},
{
  path: "/admin/keywordnegativeinfo",
  meta: {
    'title': '关键词详情',
    'keepAlive': true
  },
  name: "KeywordNegativeInfo",
  component: () => import("./views/Admin/KeywordNegativeInfo.vue")
},
{
  path: "/admin/keywordcustom",
  meta: {
    'title': '添加自定义关键词',
    'keepAlive': true
  },
  name: "KeywordCustom",
  component: () => import("./views/Admin/KeywordCustom.vue")
},
{
  path: "/admin/bbsinfo",
  meta: {
    'title': '帖子详情',
    'keepAlive': true
  },
  name: "AdminBbsInfo",
  component: () => import("./views/Admin/AdminBbsInfo.vue")
},
{
  path: "/admin/usermorebbs",
  meta: {
    'title': '作者主贴',
    'keepAlive': true
  },
  name: "UserMorebbs",
  component: () => import("./views/Admin/UserMorebbs.vue")
},
{
  path: "/admin/adminmorelist",
  meta: {
    'title': '活跃论坛',
    'keepAlive': true
  },
  name: "AdminMorelist",
  component: () => import("./views/Admin/AdminMorelist.vue")
},
{
  path: "/admin/adminmorebbs",
  meta: {
    'title': '活跃帖子',
    'keepAlive': true
  },
  name: "AdminMorebbs",
  component: () => import("./views/Admin/AdminMorebbs.vue")
},
{
  path: "/admin/adminmorebbswarning",
  meta: {
    'title': '预警帖子',
    'keepAlive': true
  },
  name: "AdminMorebbsWarning",
  component: () => import("./views/Admin/AdminMorebbsWarning.vue")
},
{
  path: "/admin/adminmember",
  meta: {
    'title': '我的账户',
    'keepAlive': true
  },
  name: "AdminMember",
  component: () => import("./views/Admin/AdminMember.vue")
},
{
  path: "/admin/adminkeywordlist",
  meta: {
    'title': '关键词列表',
    'keepAlive': true
  },
  name: "AdminKeywordList",
  component: () => import("./views/Admin/AdminKeywordList.vue")
},
{
  path: "/admin/adminecharts",
  meta: {
    'title': '论坛',
    'keepAlive': true
  },
  name: "AdmineCharts",
  component: () => import("./views/Admin/AdmineCharts.vue")
},
{
  path: "/admin/adminekeycharts",
  meta: {
    'title': '关键词',
    'keepAlive': true
  },
  name: "AdmineKeyCharts",
  component: () => import("./views/Admin/AdmineKeyCharts.vue")
},
{
  path: "/honda/shop/index",
  meta: {
    'title': '商城',
    'keepAlive': true
  },
  name: "HondaShopIndex",
  component: () => import("./views/Honda/Shop/Index.vue")
},
{
  path: "/honda/invitein",
  meta: {
    'title': '影响力认证',
    'keepAlive': true
  },
  name: "HondaInvitein",
  component: () => import("./views/Honda/Approve/HondaInvitein.vue")
},
{
  path: "/honda/invite",
  meta: {
    'title': '影响力认证',
    'keepAlive': true
  },
  name: "HondaInvite",
  component: () => import("./views/Honda/Approve/HondaInvite.vue")
},
{
  path: "/honda/inviteok",
  meta: {
    'title': '认证审核',
    'keepAlive': true
  },
  name: "HondaInviteok",
  component: () => import("./views/Honda/Approve/HondaInviteok.vue")
},
{
  path: "/honda/inviteaudit",
  meta: {
    'title': '认证审核',
    'keepAlive': true
  },
  name: "HondaInviteaudit",
  component: () => import("./views/Honda/Approve/HondaInviteaudit.vue")
},
{
  path: "/honda/approvecar",
  meta: {
    'title': '车主认证',
    'keepAlive': true
  },
  name: "ApproveCar",
  component: () => import("./views/Honda/Approve/ApproveCar.vue")
},
{
  path: "/active",
  meta: {
    'title': '活动报名',
    'keepAlive': false
  },
  name: "MotortimeActive",
  component: () => import("./views/Motortime/Active/Active.vue")
},
{
  path: "/activereg",
  meta: {
    'title': '活动报名',
    'keepAlive': false
  },
  name: "MotortimeActiveReg",
  component: () => import("./views/Motortime/Active/ActiveReg.vue")
},
{
  path: "/phonepreview",
  meta: {
    'title': '预览',
    'keepAlive': false
  },
  name: "MotortimePhonePreview",
  component: () => import("./views/Motortime/Page/PhonePreview.vue")
},
{
  path: "/grouplist",
  meta: {
    'title': '车友群',
    'keepAlive': false
  },
  name: "GroupList",
  component: () => import("./views/Admin/GroupList.vue")
},
{
  path: "/groupsearch",
  meta: {
    'title': '搜索',
    'keepAlive': false
  },
  name: "GroupSearch",
  component: () => import("./views/Admin/GroupSearch.vue")
},
{
  path: "/subaru/profile",
  meta: {
    'title': '富士范儿简介',
    'keepAlive': false
  },
  name: "SubaruProfile",
  component: () => import("./views/Subaru/Profile.vue")
},
{
  path: "/lexus/profile",
  meta: {
    'title': '凌志范儿简介',
    'keepAlive': false
  },
  name: "LexusProfile",
  component: () => import("./views/Lexus/Profile.vue")
},
{
  path: "/profile",
  meta: {
    'title': '汽车时间简介',
    'keepAlive': false
  },
  name: "MotortimeProfile",
  component: () => import("./views/Motortime/Profile.vue")
},
{
  path: "/download",
  meta: {
    'title': '汽车时间',
    'keepAlive': false
  },
  name: "Download",
  component: () => import("./views/Download/motortime.vue")
},
{
  path: "/subaru/download",
  meta: {
    'title': '富士范儿',
    'keepAlive': false
  },
  name: "SubaruDownload",
  component: () => import("./views/Download/subaru.vue")
},{
  path: "/lexus/download",
  meta: {
    'title': '凌志范儿',
    'keepAlive': false
  },
  name: "LexusDownload",
  component: () => import("./views/Download/lexus.vue")
},{
  path: "/toyota/active/activeform",
  meta: {
    'title': 'GR home 认证礼品发放',
    'keepAlive': false
  },
  name: "GrActiveForm",
  component: () => import("./views/Toyota/Active/ActiveForm.vue")
},{
  path: "/toyota/active/activeaudit",
  meta: {
    'title': 'GR home 认证礼品发放',
    'keepAlive': false
  },
  name: "GrActiveAudit",
  component: () => import("./views/Toyota/Active/ActiveAudit.vue")
},{
  path: "/subaru/active/fenxiaoform",
  meta: {
    'title': '商城合伙人报名',
    'keepAlive': false
  },
  name: "FenXiaoForm",
  component: () => import("./views/Subaru/Active/FenXiaoForm.vue")
},{
  path: "/subaru/active/fenxiaoaudit",
  meta: {
    'title': '报商城合伙人报名结果',
    'keepAlive': false
  },
  name: "FenXiaoAudit",
  component: () => import("./views/Subaru/Active/FenXiaoAudit.vue")
},
{
  path: "/redblogger",
  meta: {
    'title': '凌志范儿拍了拍你，邀请你加入',
    'description':'关注齐我们的4个账号，100%有好礼相送',
    'keepAlive': false
  },
  name: "GuideIndex",
  component: () => import("./views/redbook/guideIndex.vue")
},
{
  path: "/maoindex",
  meta: {
    'title': '折纸猫',
    'keepAlive': false
  },
  name: "MaoIndex",
  component: () => import("./views/Lexus/Mao/maoIndex.vue")
},
{
  path: "/lexus/guidepage",
  meta: {
    'title': '凌志范儿',
    'keepAlive': false
  },
  name: "LexusGuidePage",
  component: () => import("./views/Lexus/guidePage.vue")
},
{
  path: "/subaru/fatein",
  meta: {
    'title': '测试我与CROSSTREK缘分',
    'keepAlive': false
  },
  name: "FateIn",
  component: () => import("./views/Subaru/FateActive/FateIn.vue")
},{
  path: "/subaru/fateform",
  meta: {
    'title': '测试我与CROSSTREK缘分',
    'keepAlive': false
  },
  name: "FateForm",
  component: () => import("./views/Subaru/FateActive/FateForm.vue")
},{
  path: "/subaru/fateshare",
  meta: {
    'title': '测试我与CROSSTREK缘分',
    'keepAlive': false
  },
  name: "FateShare",
  component: () => import("./views/Subaru/FateActive/FateShare.vue")
},{
  path: "/subaru/fateresult",
  meta: {
    'title': '测试我与CROSSTREK缘分',
    'keepAlive': false
  },
  name: "FateResult",
  component: () => import("./views/Subaru/FateActive/FateResult.vue")
},{
  path: "/subaru/gamedemo",
  meta: {
    'title': '测试页面',
    'keepAlive': false
  },
  name: "GameDemo",
  component: () => import("./views/Subaru/Active/GameDemo.vue")
},{
  path: "/sti_doc",
  meta: {
    'title': '安装指导',
    'keepAlive': false
  },
  name: "StiDoc",
  component: () => import("./views/Subaru/Page/StiDoc.vue")
},{
  path: "/clubwechatmini",
  meta: {
    'title': '斯巴鲁官方车友会',
    'keepAlive': false
  },
  name: "WechatMini",
  component: () => import("./views/Subaru/wechatmini.vue")
},



]
});
